"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var FormWrap = function FormWrap(_ref) {
  var children = _ref.children,
    onSubmit = _ref.onSubmit,
    loading = _ref.loading,
    className = _ref.className,
    id = _ref.id;
  return /*#__PURE__*/_react["default"].createElement("form", {
    id: id,
    className: className,
    onSubmit: onSubmit
  }, /*#__PURE__*/_react["default"].createElement("fieldset", {
    disabled: loading,
    "aria-busy": loading
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-component"
  }, children)));
};
FormWrap.propTypes = {
  children: _propTypes["default"].node,
  onSubmit: _propTypes["default"].func,
  loading: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  id: _propTypes["default"].string
};
var _default = exports["default"] = FormWrap;